import { render } from "./StandardsPage.vue?vue&type=template&id=ed794aa6"
import script from "./StandardsPage.vue?vue&type=script&lang=js"
export * from "./StandardsPage.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/arda/arda-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__